import { BaseModel } from './base-model';
import { ZoneFeature } from './zones-base-interfaces';

export abstract class EcaSecaMarpolModelBase extends BaseModel
{
    abstract getEcaSecaZones(): Promise<ZoneFeature[] | null>;
    abstract getMarpolZones(): Promise<ZoneFeature[] | null>;
}

let EcaSecaMarpolModel: EcaSecaMarpolModelBase|null = null;

function setEcaSecaMarpolModel(model: EcaSecaMarpolModelBase)
{
    EcaSecaMarpolModel = model;
}

export { EcaSecaMarpolModel, setEcaSecaMarpolModel };
